<template>
  <div>
    <v-progress-linear v-if="loadingFichajes" :indeterminate="true"></v-progress-linear>
    <v-sheet height="60">
      <v-toolbar flat color="white">
        <v-btn outlined small class="mr-4" color="grey darken-2" @click="setToday" v-if="type != 'list'">Hoy</v-btn>
        <v-btn fab text small color="grey darken-2" @click="prev">
          <v-icon small>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="next">
          <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-select
          v-model="type"
          :items="types"
          item-value="value"
          item-text="text"
          dense
          outlined
          hide-details
          class="mr-2 ml-2"
          label="Mostrar"
          v-if="!isXsOnly"
        ></v-select>
        <v-select
          v-model="weekday"
          :items="weekdays"
          item-value="value"
          item-text="text"
          dense
          outlined
          hide-details
          label="Días de la semana"
          class="mr-2 ml-2"
          v-if="!isXsOnly && type != 'list'"
        ></v-select>
      </v-toolbar>
    </v-sheet>
    <v-sheet height="60" v-if="isXsOnly">
      <v-toolbar flat color="white">
        <v-select
          v-model="type"
          :items="types"
          item-value="value"
          item-text="text"
          dense
          outlined
          hide-details
          class="mr-2"
          label="Mostrar"
        ></v-select>
        <v-select
          v-if="type != 'list'"
          v-model="weekday"
          :items="weekdays"
          item-value="value"
          item-text="text"
          dense
          outlined
          hide-details
          label="weekdays"
          class
        ></v-select>
      </v-toolbar>
    </v-sheet>
    <v-sheet
      height="600"
      :style="type == 'list' ? 'display:none;margin-top: 4px;': 'margin-top: 4px;'"
    >
        <v-calendar ref="calendar"
                    v-model="value"
                    color="primary"
                    :weekdays="weekday"
                    :type="typeCalendar"
                    :events="events"
                    :event-overlap-mode="mode"
                    :event-overlap-threshold="30"
                    :event-color="getEventColor"
                    @change="updateRange"
                    :event-height="15"
                    :interval-height="60"
                    :event-more="true"
                    @click:more="clickedMore"
                    @click:event="showEvent">
            <template v-slot:event="{event}" v-if="ahora">
                <div>
                    {{ printEventTime(event.start) }} - {{ event.name }}
                </div>
            </template>

        </v-calendar>
    </v-sheet>
    <v-data-table
      v-if="type == 'list'"
      :headers="headers"
      :items="fichajes"
      disable-pagination="true"
      hide-default-footer
    >
      <template slot="no-data">
        <v-alert
          :value="true"
          outlined
          type="info"
          color="info"
          icon="warning"
          class="ma-2"
        >No existen fichajes para mostrar</v-alert>
      </template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.markDateTimeFec
                }}</td>
                <td class="text-xs-left">{{ props.item.incidence }}</td>
                <td class="text-xs-left">{{ props.item.incidenceType }}</td>
            </template>
    </v-data-table>
    <v-dialog v-model="dialogDetalleEvent" width="500" v-if="!!eventSel">
      <v-card class="elevation-12">
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            <span>Detalle del Fichaje</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-form class="ma-3 mt-8">
            <v-text-field v-model="eventSel.start" label="Fecha" readonly></v-text-field>
            <v-text-field v-model="eventSel.name" label="Tipo" readonly></v-text-field>
            <v-text-field v-model="eventSel.description" label="Tipo Incidencia" v-if="!!eventSel.description" readonly></v-text-field>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialogDetalleEvent=false" class="mr-5">Cerrar</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import fichajeServices from "@/services/fichajeServices.js";
import tipoIncidenciaServices from "@/services/tipoIncidenciaServices.js";
const moment = require("moment");
require("moment/locale/es");

export default {
  data: () => ({
        ahora: false,
        dialogDetalleEvent: false,
    loadingFichajes: true,
    tiposIncidencias: [],
    fichajes: [],
    //formatDate: "DD/MM/YYYY HH:mm:ss",
    formatDateCalendar: "YYYY-MM-DD HH:mm:ss",
    type: "month",
    types: [
      { value: "month", text: "Mes" },
      { value: "week", text: "Semana" },
      { value: "day", text: "Día" },
      { value: "list", text: "Listado" }
    ],
    mode: "stack",
    weekday: [1, 2, 3, 4, 5, 6, 0],
    weekdays: [
      {
        text: "Todos los días de la semana",
        value: [1, 2, 3, 4, 5, 6, 0]
      },
      {
        text: "Solo días laborales",
        value: [1, 2, 3, 4, 5]
      }
    ],
    start: null,
    end: null,
    value: "",
    eventSel: null,
    events: [],
    headers: [
      { text: "Fecha", value: "markDateTimeFec" },
      { text: "Tipo", value: "incidence" },
      { text: "Tipo Incidencia", value: "incidenceType" }
    ]
  }),
  created() {
    this.$store.commit("global/SET_MIGA", [
      { text: "Inicio", href: "/" },
      { text: "Consultar Fichajes", href: "/consultar-fichajes" }
    ]);
  },
  computed: {
    typeCalendar: function() {
      if (this.type == "list") {
        return "month";
      } else {
        return this.type;
      }
    },
    user: function() {
      return this.$store.state.authentication.user;
    },
    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }

      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? "" : endMonth;

      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? "" : endYear;

      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);

      switch (this.type) {
        case "month":
        case "list":
          return `${startMonth} ${startYear}`;
        case "week":
        case "4day":
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
        case "day":
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return "";
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long"
      });
    },
    isXsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isSmAndUp() {
      return this.$vuetify.breakpoint.smAndUp;
    }
  },
  methods: {
    printEventTime(eventTime) {
      if (!!eventTime) {
          return moment(eventTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
      } else {
          return '';
      }
    },
    showEvent({ nativeEvent, event }) {
      if (!!event) {
        this.eventSel = event;
        this.dialogDetalleEvent = true;
      }
    },
    clickedMore(data) {
      this.type = "day";
      this.value = data.date;
    },
    obtenerFichajes(start, end) {
      var that = this;
      this.loadingFichajes = true;
      var dataFindMark = {
        employeeId: this.user.employeeId,
        start: moment.utc(start).format(that.getFormatoFechaToServer),
        end: moment.utc(end).format(that.getFormatoFechaToServer),
        pageNumber: 1,
        pageSize: 1000,
        sortDirection: "Descending"
      };

      const promises = [
        tipoIncidenciaServices.getTipos(),
        fichajeServices.getFichajes(dataFindMark)
      ];
      Promise.all(promises).then(values => {
        this.loadingFichajes = false;
        this.ahora = true;
        this.tiposIncidencias = values[0];
        this.fichajes = values[1];
        this.events = [];
        if (!!this.fichajes) {
          this.fichajes.forEach(item => {
            item.markDateTimeFec = moment
              .utc(item.markDateTime)
              .local()
              .format(that.getFormatoFechaToView);

            item.incidence =
              item.incidenceTypeId > 0 ? "Fichaje con incidencia" : "Fichaje";

            var typeI = that.tiposIncidencias.find(
              itemTipo => itemTipo.incidenceTypeId == item.incidenceTypeId
            );

            if (!!typeI) {
              item.incidenceType = typeI.name;
            }
            this.events.push({
              name:
                item.incidenceTypeId > 0 ? "Fichaje con incidencia" : "Fichaje",
              description: !!item.incidenceType ? item.incidenceType : "",
              start: moment
                .utc(item.markDateTime)
                .local()
                .format(this.formatDateCalendar),
              end: moment
                .utc(item.markDateTime)
                .local()
                .format(this.formatDateCalendar),
              color: item.incidenceTypeId > 0 ? "lime darken-3" : "teal"
            });
            console.log(this.events);
          });

          if (that.type == "day") {
            setTimeout(function() {
              const events = that.$el.getElementsByClassName("v-event-timed");
              if (!!events && !!events[0]) {
                events[0].scrollIntoView();
                }
            }, 10);
          }
        }
      });
    },
    setToday() {
      this.value = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    getEventColor(event) {
      return event.color;
    },
    nth(d) {
      return d > 3 && d < 21
        ? "th"
        : ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"][d % 10];
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      this.obtenerFichajes(min, max);

      this.start = start;
      this.end = end;
      this.events = events;
    }
  }
};
</script>
<style>
.v-calendar-weekly__day-label {
  margin: 0px 0 !important;
  height: 21px;
}
.v-calendar-weekly__day-label .v-btn--fab.v-size--small {
  height: 18px !important;
  width: 20px !important;
  font-size: 10px;
  margin-top: -2px;
}
.v-calendar .v-event,
.v-calendar .v-event-more,
.v-calendar .v-event-timed {
  font-size: 11px !important;
}
.v-event-more {
  background: #fafafa !important;
}
</style>